var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"text-align":"center","font-size":"21px"}},[_c('v-btn',{attrs:{"color":"primary","block":"","outline":""},on:{"click":function($event){$event.stopPropagation();return _vm.downloadXlsxTemplate()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v("Download XLSX template ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }